<script>
export default {
   props: {
      isPreview: {
         type: Boolean,
         default: false
      }
   },
   data() {
      return {
      email: '',
      emailState: null,
      emailFeedback: '',
      selected: 1
      };
   },
   watch: {
      selected(newVal) {
         if (newVal === 0) {
            this.email = '';
            this.emailState = null;
            this.emailFeedback = '';
            this.$emit('email-to-used', null);
         }
      }
      },
   methods: {
      validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const dummyEmailPattern = /(.+@dummy\.com.*)|(.+@dummy\.co\.jp)|(dummy@nta.*)/i;
      if (this.email === '') {
         this.emailState = null;
         this.emailFeedback = '';
      } else if (!emailPattern.test(this.email) || dummyEmailPattern.test(this.email)) {
         this.email = '';
         this.emailState = false;
         this.emailFeedback = this.$t('checkout_by_phone.email_invalid');
      } else {
         this.emailState = true;
         this.emailFeedback = '';
         this.$emit('email-to-used', this.email);
      }
      },
      /**
       * Public method called by parent before checkout submission.
       * Returns true if valid, false otherwise.
       */
      validate() {
         if (this.selected === 1) {
            console.log('Validating email:', this.email);
            if (!this.email || this.email.trim() === '') {
               this.emailState = false;
               this.emailFeedback = this.$t('checkout_by_phone.email_required');
               return false;
            }
            this.validateEmail();
            return this.emailState === true;
         }
         // "No need to enter email" is selected — valid
         return true;
      }
   }
};
</script>

<template>
   <div class="mt-4 border p-3 rounded" v-if="!isPreview">
      <b-form-group v-slot="{ ariaDescribedby }">
         <div>
            <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="email-radio" :value="1">{{ $t('checkout_by_phone.email_radio_label') }}</b-form-radio>
            <b-form-input
               id="email-input"
               v-model="email"
               type="email"
               :state="emailState"
               @blur="validateEmail"
               :disabled="selected === 0"
               class="mb-2"
            ></b-form-input>
            <b-form-invalid-feedback v-if="emailFeedback">{{ emailFeedback }}</b-form-invalid-feedback>
            <div class="mb-2">{{ $t('checkout_by_phone.email_note') }}</div>
         </div>
         <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="email-radio" :value="0">{{ $t('checkout_by_phone.no_need_to_enter_email') }}</b-form-radio>
      </b-form-group>
   </div>
   <div class="mt-4 border p-3 rounded" v-else-if="isPreview && email">
      <div class="d-flex">
         <span class="mr-2">{{ $t('checkout_by_phone.email_radio_label') }}:</span>
         <span>{{ email }}</span>
      </div>
   </div>
</template>